<template>
  <v-container data-aos="fade">
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm4>
        <v-img :src="image" class="elevation-2 flyer"></v-img>
        <v-btn color="primary" href="mailto:contact@chefnaturelle.com?subject=Last of The Summer Veg">Book Now</v-btn>
      </v-flex>
      <v-flex xs12 sm7>
        <h1>Last of The Summer Veg</h1>
        <v-layout class="pricing-details" row justify-space-between>
          <v-flex xs8 class="text-xs-left">
            Saturday 21st Sept 2019 - 7pm to 10pm - Hertford
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            £35
          </v-flex>
        </v-layout>
        <p class="font-weight-bold">
          In this Farm to Table dinner, we will feast on the season's last produce at the charming
          <a href="https://mudlarksgarden.org.uk/cafe/" target="_blank">Mudlarks Garden Café</a>. The menu tells the
          story of the last of the summer veg and showcases beautiful and tasty produce from a local farm and
          from my allotment.
        </p>
        <p>
          I will welcome you at 7pm with nibbles. You will have a little time to get comfy and get to know the other
          guests before finding your seat to tuck into your three course plant-based meal focusing on organic,
          wholesome and local ingredients.
        </p>
        <p>
          If you wish to enhance your experience, matching wines have been selected by the very knowledgable wine
          specialist at <a href="https://www.cavavin.co.uk" target="_blank">Cavavin</a> and will be available to
          purchase by the bottle from
          <a href="https://www.cavavin.co.uk/contact/" target="_blank">their shop in Hertford</a>
          (full details and tasting notes will be provided upon booking). You are also welcome to bring other
          alcoholic or non-alcoholic drinks. Wine glasses and corkscrews will be provided - no corkage fee!
        </p>
        <p>
          Bring friends and family or come alone to meet other lovely people and have a good time.
        </p>
        <p>Tickets are £35 per person and include nibbles and a three-course meal.</p>
        <p class="font-weight-bold">There are 20 spaces available,
          <contact-link subject="Last of the Summer Veg">contact me</contact-link>
          to book.
        </p>
        <div class="terms">
          <p class="underline">Please note:</p>
          <ul>
            <li>Some sittings (and the bathroom) are located on the first floor with no lift. If this is an issue,
              please let me know at the time of booking so that I can allocate seats accordingly.</li>
            <li>Unfortunately, this event is not suitable for anyone suffering from food allergies.
              If you have any food intolerances, please <contact-link subject="Last of the Summer Veg"></contact-link>
              before booking and I will be happy to discuss alternatives.</li>
          </ul>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ContactLink from '@/components/ContactLink'

export default {
  components: {
    ContactLink
  },
  data: () => ({
    image: require('@/assets/images/last-of-the-summer-veg.jpg?vuetify-preload')
  })
}
</script>

<style scoped>
h1 {
  color: rgb(171,182,78);
  font-family: 'Karla', sans-serif;
  font-weight: bold;
  text-transform: none;
  font-size: 40px;
}

.flyer {
  margin-bottom: 15px;
}

.underline {
  text-decoration: underline;
}

.terms {
  font-size: 15px;
}

.pricing-details {
  color: rgb(171,182,78);
  border-bottom: 1px solid rgb(171,182,78);
  margin-bottom: 23px;
  padding-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.v-image {
  margin-top: 14px;
}

strong {
  color: rgb(171,182,78);
  font-size: 25px;
}
</style>
